export const LOGIN = 'login/LOGIN';
export const LOGIN_SUCCESS = 'login/LOGIN_SUCCESS';
export const REGISTER_SUCCESS = 'login/REGISTER_SUCCESS';
export const LOGIN_ERROR = 'login/LOGIN_ERROR';
export const LOGOUT = 'login/LOGOUT';
export const LOGOUT_CLEANUP = 'logout/cleanup';

export const REQUEST_OTP = 'login/REQUEST_OTP';
export const REQUEST_OTP_SUCCESS = 'login/REQUEST_OTP_SUCCESS';
export const REQUEST_OTP_ERROR = 'login/REQUEST_OTP_ERROR';

export const RESENT_OTP = 'login/RESENT_OTP';
export const FORGOT_PASSWORD = 'login/FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'login/FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'login/FORGOT_PASSWORD_ERROR';
export const RESET_FORGOT_PASSWORD = 'login/RESET_FORGOT_PASSWORD';

export const CHANGE_PASSWORD = 'login/CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'login/CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_ERROR = 'login/CHANGE_PASSWORD_ERROR';

export const GET_USER_PERMISSIONS = 'login/GET_USER_PERMISSIONS';
export const GET_USER_PERMISSIONS_SUCCESS =
	'login/GET_USER_PERMISSIONS_SUCCESS';
export const GET_USER_PERMISSIONS_ERROR = 'login/GET_PERMISSIONS_ERROR';

export const GET_USER_INFO = 'login/GET_USER_INFO';
export const GET_USER_INFO_SUCCESS = 'login/GET_USER_INFO_SUCCESS';
export const GET_USER_INFO_ERROR = 'login/GET_USER_INFO_ERROR';

export const SAVE_LOCAL_USER_INFO = 'login/SAVE_LOCAL_USER_INFO';

export const GET_CSRF_TOKEN = 'login/GET_CSRF_TOKEN';

export const VERIFY_USER = 'login/VERIFY_USER';
export const VERIFY_USER_SUCCESS = 'login/VERIFY_USER_SUCCESS';
export const VERIFY_USER_ERROR = 'login/VERIFY_USER_ERROR';

export const UPDATE_USER_GROUP = 'login/UPDATE_USER_GROUP';
export const UPDATE_USER_GROUP_SUCCESS = 'login/UPDATE_USER_GROUP_SUCCESS';
export const UPDATE_USER_GROUP_ERROR = 'login/UPDATE_USER_GROUP_ERROR';

export const GET_USER_GROUP_LIST = 'login/GET_USER_GROUP_LIST';
export const GET_USER_GROUP_LIST_SUCCESS = 'login/GET_USER_GROUP_LIST_SUCCESS';
export const GET_USER_GROUP_LIST_ERROR = 'login/GET_USER_GROUP_LIST_ERROR';
export const RESET_USER_GROUP_LIST = 'login/RESET_USER_GROUP_LIST';

export const UPDATE_USER_MID = 'login/UPDATE_USER_MID';
export const UPDATE_USER_MID_SUCCESS = 'login/UPDATE_USER_MID_SUCCESS';
export const UPDATE_USER_MID_ERROR = 'login/UPDATE_USER_MID_ERROR';

export const SAVE_MID_DATA = 'login/SAVE_MID_DATA';

export const SET_CAPTCHA_TOKEN = 'SET_CAPTCHA_TOKEN';
export const SET_CAPTCHA_ERROR = 'SET_CAPTCHA_ERROR';
